import "@/App.css";
import { useState, useEffect, createContext, useContext } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import WhyNevada from "@/components/WhyNevada";
import Services from "@/components/Services";
import Serve from "@/components/Serve";
import Process from "@/components/Process";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Admin from "@/pages/Admin";

const LanguageContext = createContext({ lang: "en", setLang: () => {} });
export const useLanguage = () => useContext(LanguageContext);

const GRAIN =
  "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")";

const Landing = () => (
  <main className="bg-[#0A1128] font-body text-white antialiased" data-testid="landing-page">
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 z-[80] opacity-[0.05] mix-blend-overlay"
      style={{ backgroundImage: GRAIN }}
    />
    <Header />
    <Hero />
    <Marquee />
    <WhyNevada />
    <Services />
    <Serve />
    <Process />
    <About />
    <Contact />
    <Footer />
  </main>
);

function App() {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      <MotionConfig reducedMotion="user">
        <ReactLenis root options={{ lerp: 0.08, duration: 1.2 }}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#101836",
                border: "1px solid rgba(212,175,55,0.45)",
                color: "#fff",
              },
            }}
          />
        </ReactLenis>
      </MotionConfig>
    </LanguageContext.Provider>
  );
}

export default App;
